import * as React from 'react';
import theme from '../../styles/theme';

function SvgInfo() {
  return (
    <svg
      width={24}
      height={24}
      fill="transparent"
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.9305 22.0151C18.4534 22.0151 22.9305 17.5379 22.9305 12.0151C22.9305 6.49223 18.4534 2.01508 12.9305 2.01508C7.40769 2.01508 2.93054 6.49223 2.93054 12.0151C2.93054 17.5379 7.40769 22.0151 12.9305 22.0151Z"
        stroke={theme.colors.mainColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.9305 16.0151V12.0151"
        stroke={theme.colors.mainColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.9305 8.01508H12.9405"
        stroke={theme.colors.mainColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SvgInfo;
